import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/layout/index.vue'

Vue.use(Router)
export default new Router({
  mode: 'history',
  scrollBehavior: () => ({x: 0, y: 0}),
  routes: [
    {
      path: '/',
      name: 'Home',
      redirect: '/workbench',
      meta: {
        hide: true
      }
    },
    {
      path: '/workbench',
      component: Layout,
      meta: {
        title: '工作台',
        icon: 'workbench'
      },
      children: [{
        path: '',
        name: 'Workbench',
        component: () => import('@/views/workbench/index.vue')
      }]
    },
    {
      path: '/cost',
      component: Layout,
      meta: {
        title: '费用',
        icon: 'cost'
      },
      children: [{
        path: 'price',
        name: 'Cost_Price',
        component: () => import('@/views/cost/price/index.vue'),
        meta: {
          title: '最新报价',
          auth: 'Cost_Price'
        }
      }]
    },
    {
      path: '/vat',
      component: Layout,
      meta: {
        title: 'VAT中心',
        icon: 'vat'
      },
      children: [{
        path: 'declare',
        name: 'Vat_Declare',
        component: () => import('@/views/vat/declare/index.vue'),
        meta: {
          title: '我要申报',
        }
      },
      {
        path: 'number',
        name: 'Vat_Number',
        component: () => import('@/views/vat/number/index.vue'),
        meta: {
          title: '税号管理',
        }
      },
      {
        path: 'file',
        name: 'Vat_File',
        component: () => import('@/views/vat/file/index.vue'),
        meta: {
          title: '税务文件',
        }
      },
      {
        path: 'order',
        name: 'Vat_Order',
        component: () => import('@/views/vat/order/index.vue'),
        meta: {
          title: 'VAT订单',
        }
      }]
    },
    {
      path: '/tool/case',
      component: Layout,
      meta: {
        title: '案件管理',
        icon: 'case'
      },
      children: [{
        path: 'monitor',
        name: 'Tool_Monitor',
        component: () => import('@/views/tool/monitor/index.vue'),
        meta: {
          title: '商标监测',
          auth: 'Tool_Monitor'
        }
      },
      {
        path: 'trademark',
        name: 'Tool_Trademark',
        component: () => import('@/views/tool/trademark/index.vue'),
        meta: {
          title: '商标跟进',
          auth: 'Tool_Trademark'
        }
      },
      {
        path: 'patent/follow',
        name: 'Tool_Patent',
        component: () => import('@/views/tool/patent/follow/index.vue'),
        meta: {
          title: '专利跟进',
          auth: 'Tool_Patent'
        }
      },
      {
        path: 'patent/annual_fee',
        name: 'Tool_Patent_AnnualFee',
        component: () => import('@/views/tool/patent/annual_fee/index.vue'),
        meta: {
          title: '年费监测',
          auth: 'Tool_Patent_AnnualFee'
        }
      }]
    },
    {
      path: '/document',
      component: Layout,
      meta: {
        title: '官文管理',
        icon: 'document'
      },
      children: [{
        path: 'certificate',
        name: 'Document_Certificate',
        component: () => import('@/views/document/certificate/index.vue'),
        meta: {
          title: '证书管理',
          auth: 'Document_Certificate'
        }
      },
      {
        path: 'receipt',
        name: 'Document_Receipt',
        component: () => import('@/views/document/receipt/index.vue'),
        meta: {
          title: '回执管理',
          auth: 'Document_Receipt'
        }
      }]
    },
    {
      path: '/cost',
      component: Layout,
      meta: {
        title: '费用',
        icon: 'cost'
      },
      children: [{
        path: 'order',
        name: 'Cost_Order',
        component: () => import('@/views/cost/order/index.vue'),
        meta: {
          title: '我的订单',
          auth: 'Cost_Order'
        }
      }]
    },
    {
      path: '/custom',
      component: Layout,
      meta: {
        title: '产品定制',
        icon: 'custom'
      },
      children: [{
        path: 'list',
        name: 'Custom_List',
        component: () => import('@/views/custom/list/index.vue'),
        meta: {
          title: '在线选品',
          auth: 'Custom_List'
        }
      },
      {
        path: 'mail',
        name: 'Custom_Mail',
        component: () => import('@/views/custom/mail/index.vue'),
        meta: {
          title: '邮寄打标',
          auth: 'Custom_Mail'
        }
      },
      {
        path: 'link',
        name: 'Custom_Link',
        component: () => import('@/views/custom/link/index.vue'),
        meta: {
          title: '上架链接',
          auth: 'Custom_Link'
        }
      },
      {
        path: 'site_service',
        name: 'Custom_Site_Service',
        component: () => import('@/views/custom/site/service/index.vue'),
        meta: {
          title: '服务类建站',
          auth: 'Custom_Site_Service',
          className: 'custom-site-service'
        }
      },
      {
        path: 'detail/:id',
        name: 'Custom_Detail',
        component: () => import('@/views/custom/detail/index.vue'),
        meta: {
          title: '产品详情',
          hide: true,
          auth: 'Custom_Detail'
        }
      },
      {
        path: 'check',
        name: 'Custom_Check',
        component: () => import('@/views/custom/check/index.vue'),
        meta: {
          title: '信息核对',
          hide: true,
          auth: 'Custom_Check'
        },
      },
      {
        path: 'cart',
        name: 'Custom_Cart',
        component: () => import('@/views/custom/cart/index.vue'),
        meta: {
          title: '购物车',
          hide: true,
          auth: 'Custom_Cart'
        }
      }]
    },
    {
      name: 'Sign',
      path: '/sign/:api/:id',
      component: () => import('@/views/sign/index.vue'),
      meta: {
        hide: true
      }
    },
    {
      name: 'Login',
      path: '/login',
      component: () => import('@/views/login/index.vue'),
      meta: {
        hide: true
      }
    },
    {
      path: '*',
      redirect: '/',
      meta: {
        hide: true
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js